import { InputBase, styled } from '@mui/material'
import { INPUT_MAX_WIDTH } from '../../../styles/muiTheme/GlobalStyles'

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  width: '100%',
  maxWidth: INPUT_MAX_WIDTH,
  fontSize: theme.typography.body_m_regular.fontSize,
  fontWeight: theme.typography.body_m_regular.fontWeight,
}))
